import React, { useState, useEffect, useCallback } from 'react';
import { getData, updateData } from '../../services/registrationDatesServices';
import { Button, Form } from 'react-bootstrap';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';

const Registrationdates = () => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState({
    id: '',
    conetitle: '',
    conedate: '',
    ctwotitle: '',
    ctwodate: '',
    cthreetitle: '',
    cthreedate: '',
  });

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getData();
      if (data && data.length > 0) {
        setForm(data[0]);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setTimeout(() => setLoading(false), 500);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const diffInDays = (start, end) => {
    const s = new Date(start);
    const e = new Date(end);
    s.setHours(0, 0, 0, 0);
    e.setHours(0, 0, 0, 0);
    return Math.floor((e - s) / (1000 * 60 * 60 * 24));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!form.conetitle) newErrors.conetitle = 'Early Bird Title is required';
    if (!form.conedate) newErrors.conedate = 'Early Bird Date is required';

    if (!form.ctwotitle) newErrors.ctwotitle = 'Mid-Term Title is required';
    if (!form.ctwodate) newErrors.ctwodate = 'Mid-Term Date is required';

    if (!form.cthreetitle) newErrors.cthreetitle = 'Final Call Title is required';
    if (!form.cthreedate) newErrors.cthreedate = 'Final Call Date is required';

    if (form.conedate && form.ctwodate) {
      const diff = diffInDays(form.conedate, form.ctwodate);
      if (diff < 30) {
        newErrors.ctwodate = 'Mid-Term date must be at least 30 days after Early Bird date';
      }
    }

    if (form.ctwodate && form.cthreedate) {
      const diff = diffInDays(form.ctwodate, form.cthreedate);
      if (diff < 30) {
        newErrors.cthreedate = 'Final Call date must be at least 30 days after Mid-Term date';
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const result = await updateData(form);
      if (result.status === 200 || result.status === 201) {
        toast.success('Saved successfully!', { position: 'top-right' });
        fetchData();
      } else {
        toast.error(result?.message || 'Failed to update data.', { position: 'top-right' });
      }
    } catch (error) {
      console.error('Error updating data:', error);
      toast.error('Server error. Try again.');
    }
  };

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: '300px' }}>
            <Spinner />
          </div>
        ) : (
          <div>
            <div className="container-fluid p-4">
              <p className="mb-3 fs-4">
                Basic Setup & File upload / Registration Setup <b>/ Registration Dates</b>
              </p>

              <Form onSubmit={handleSubmit}>
                <div className="row">
                  <Form.Group className="col-md-6 mb-3">
                    <Form.Label>Early Bird Title *</Form.Label>
                    <Form.Control
                      type="text"
                      name="conetitle"
                      value={form.conetitle}
                      onChange={handleChange}
                      isInvalid={!!errors.conetitle}
                    />
                    <Form.Control.Feedback type="invalid">{errors.conetitle}</Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="col-md-6 mb-3">
                    <Form.Label>Early Bird Date *</Form.Label>
                    <Form.Control
                      type="date"
                      name="conedate"
                      value={form.conedate}
                      onChange={handleChange}
                      isInvalid={!!errors.conedate}
                    />
                    <Form.Control.Feedback type="invalid">{errors.conedate}</Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="col-md-6 mb-3">
                    <Form.Label>Mid-Term Title *</Form.Label>
                    <Form.Control
                      type="text"
                      name="ctwotitle"
                      value={form.ctwotitle}
                      onChange={handleChange}
                      isInvalid={!!errors.ctwotitle}
                    />
                    <Form.Control.Feedback type="invalid">{errors.ctwotitle}</Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="col-md-6 mb-3">
                    <Form.Label>Mid-Term Date *</Form.Label>
                    <Form.Control
                      type="date"
                      name="ctwodate"
                      value={form.ctwodate}
                      onChange={handleChange}
                      isInvalid={!!errors.ctwodate}
                    />
                    <Form.Control.Feedback type="invalid">{errors.ctwodate}</Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="col-md-6 mb-3">
                    <Form.Label>Final Call Title *</Form.Label>
                    <Form.Control
                      type="text"
                      name="cthreetitle"
                      value={form.cthreetitle}
                      onChange={handleChange}
                      isInvalid={!!errors.cthreetitle}
                    />
                    <Form.Control.Feedback type="invalid">{errors.cthreetitle}</Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="col-md-6 mb-3">
                    <Form.Label>Final Call Date *</Form.Label>
                    <Form.Control
                      type="date"
                      name="cthreedate"
                      value={form.cthreedate}
                      onChange={handleChange}
                      isInvalid={!!errors.cthreedate}
                    />
                    <Form.Control.Feedback type="invalid">{errors.cthreedate}</Form.Control.Feedback>
                  </Form.Group>
                </div>

                <Button variant="success" type="submit">
                  Submit
                </Button>
              </Form>
            </div>
            <Footer />
          </div>
        )}
      </div>
    </div>
  );
};

export default Registrationdates;
